import React, {Component} from 'react'
import {Link} from 'gatsby'
import { Menu } from 'semantic-ui-react'
import * as styles from './styles/header.module.css'

export default class UserIconMobile extends Component {
	render() {
		return(
			<Menu.Item
				as={Link}
				to="/my-account/"
				className={styles.mobileItem}
				icon="user"
				onClick={this.props.closeModal}
			/>
		)
	}
}